<template>
    <div class="container" :class="{'container2': $iosHeightDiv2() == 'isIosHeight', 'container3': $iosHeightDiv2() == 'isIosHeight2'}" >
        <div class="activeImg">
            <img class="sk-image" />
        </div>
        <div class="tab">
            <div class="van-tabs van-tabs--line">
                <div class="van-tabs__wrap van-tabs__wrap--scrollable van-hairline--top-bottom">
                    <div role="tablist" class="van-tabs__nav van-tabs__nav--line">
                        <div role="tab" class="van-tab van-tab--active" style="flex-basis: 44%;">
                            <span class="van-ellipsis">
                                <div class="tabItem">
                                    <div class="tabTime">
                                        <span class="sk-text sk-text-5">10-09 10:30</span>
                                    </div>
                                    <div class="tabStatu">
                                        <span class="sk-text sk-text-7">抢购进行中</span>
                                    </div>
                                </div>
                            </span>
                        </div>
                        <div role="tab" class="van-tab van-tab--active" style="flex-basis: 44%;">
                            <span class="van-ellipsis">
                                <div class="tabItem">
                                    <div class="tabTime">
                                        <span class="sk-text sk-text-5">10-09 10:30</span>
                                    </div>
                                    <div class="tabStatu">
                                        <span class="sk-text sk-text-7">抢购进行中</span>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="van-tabs__content">
                    <div role="tabpanel" class="van-tab__pane">
                        <div class="body">
                            <div v-for="(item, index) in content" :key="index">
                                <div class="special">
                                    <div class="img-box">
                                        <img class="sk-image" />
                                    </div>
                                    <div class="mainPart">
                                        <div class="sk-text sk-text-1"></div>
                                        <div class="case">
                                            <div class="others">
                                                <div class="price">
                                                    <div class="sk-text sk-text-2">
                                                    </div>
                                                    <div class="progress-box">
                                                        <div class="sk-text sk-text-3">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="btn sk-text sk-text-4">去抢购</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="hr"></div>
                            </div>
                        </div>
                    </div>
                    <div class="tabTips">
                        <div class="toEnd inProgress">
                            <div class="lightning">
                                <div class="sk-text">距离结束</div>
                            </div>
                            <div class="countDown">
                                <div class="count">
                                    <div class="van-count-down">
                                        <div class="sk-text sk-text-6">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'specialZoneSkeleton',
    data () {
        return {
            content: [1, 2, 3, 4, 5]
        }
    }
}
</script>
<style lang="scss" scoped>
// 进度条样式
/deep/ .progress {
    position: relative;
    z-index: 99;
}
/deep/ .mt-progress-runway {
    background-color: #ffc9ca;
}
/deep/ .mt-progress-progress {
    background-color: #ff4d4f;
}
.progressSellOut {
    /deep/ .mt-progress-progress {
        background-color: #ababab !important;
    }
}
// tab切换样式
/deep/ .van-tabs {
    height: 100%;
}
/deep/ .van-tabs__wrap--scrollable .van-tab {
    padding: 0;
}
/deep/ .van-tabs__nav {
    padding: 0 !important;
    background-color: #ff4d4f;
    border-bottom-left-radius: 40px;
    border-bottom-right-radius: 40px;
}
/deep/ .van-tabs__nav .van-tab {
    flex-basis: 50% !important;
}
/deep/ .van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
    border: none;
}
/deep/ .van-tabs__content {
    height: calc(100% - 212px);
    overflow: auto;
}
/deep/.van-tabs--line .van-tabs__wrap {
    position: relative;
    height: 212px;
    padding: 0;
}
.container {
    height: calc(100% - 100px);
    position: relative;
    overflow: hidden;
    &.container2{
        height: calc(100% - 145px);
    }
    &.container3{
        height: calc(100% - 192px);
    }
    .activeImg {
        img {
            width: 100%;
            height: 100%;
            border-radius: 16px;
        }
        background: #ff4d4f;
        padding: 0 24px;
        height: 262px;
    }
    .tab {
        height: calc(100% - 262px);
        text-align: center;
    }
    .tabItem {
        height: 204px;
        color: #ffffff;
        img {
            height: 262px;
        }
        .tabTime {
            font-weight: bold;
            font-size: 32px;
            padding-top: 16px;
        }
        .tabStatu {
            font-size: 24px;
            padding: 0 0 122px 0;
            transform-origin: center 0%;
        }
    }
}
.body {
    margin: 0 24px 0 24px;
    background-color: #fff;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
}
.special {
    display: flex;
    justify-content: flex-start;
    padding: 24px;
    .img-box {
        width: 192px;
        height: 192px;
        background-color: #fafafa;
        border-radius: 10px;
        display: flex;
        img {
            align-self: center;
            justify-self: center;
            border-radius: 10px;
            display: inline-block;
            margin: 0 auto;
            background: #f2f3f5;
            object-fit: cover;
        }
    }
}
.mainPart {
    position: relative;
    padding-left: 24px;
    text-align: left;
    width: calc(100% - 192px);
    .case {
        position: absolute;
        width: calc(100% - 32px);
        bottom: 0px;
        .others {
            padding-top: 24px;
            position: relative;
            .price {
                width: 250px;
                .discount {
                    height: 48px;
                }
                .progress-box {
                    height: 28px;
                    display: inline-flex;
                    align-items: center;
                }
            }
            .btn {
                box-sizing: border-box;
                position: absolute;
                right: 0;
                bottom: 0;
                border-radius: 50px;
                background-color: #ff4d4f;
                color: #ffffff;
                font-size: 26px;
                padding: 0 40px;
                height: 48px;
                line-height: 48px;
            }
        }
    }
}
.tabTips {
    position: absolute;
    top: 116px;
    padding: 32px 0;
    width: calc(100% - 48px);
    margin: 0 24px;
    background-color: #fff;
    border-radius: 16px 16px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 2px solid #eeeeee;
    .toEnd {
        &.isCome {
            color: #999999;
        }
        &.inProgress {
            color: #000000;
        }
        display: flex;
        align-items: center;
        padding-right: 32px;
        font-size: 24px;
        font-weight: 400;
        .lightning {
            display: flex;
            align-items: center;
            img {
                width: 32px;
                height: 32px;
            }
            div {
                font-size: 24px;
                height: 32px;
                line-height: 32px;
            }
        }
        .countDown {
            padding-left: 16px;
        }
    }
}
.hr {
    border-top: 2px solid #eeeeee;
    margin: 0 24px;
}
@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
.sk-image {
    background: #EFEFEF !important;
}
.sk-text {
    background-origin: content-box !important;
    background-clip: content-box !important;
    background-color: transparent !important;
    color: transparent !important;
    background-repeat: repeat-y !important;
    background-image: linear-gradient(90deg, #eeeeee 0%, #ddd 30%, #eee 63%) !important;
    position: relative !important;
    background-size: 400% 100%;
    animation: skeleton-loading 1.4s ease infinite;
    margin-bottom: 10px;
}
.sk-text-1 {
    height: 80px;
}
.sk-text-2 {
    height: 48px;
    width: 150px;
}
.sk-text-3 {
    height: 28px;
    width: 200px;
    border-radius: 30px;
}
.sk-text-4 {
    height: 48px;
    position: absolute !important;
}
.sk-text-5 {
    padding: 0 30px;
}
.sk-text-7 {
    padding: 0 30px;
}
.sk-text-6 {
    width: 250px;
    height: 32px;
}
</style>
